import { 
  ButtonLooks, 
  ButtonSizes,
  FontIcon,
  FontIcons, 
  ButtonLink
} from '@brandfolder/react';
import React, { FunctionComponent } from 'react';

interface ReportsButtonProps {
  orgSlug: string
}

const ReportsButton: FunctionComponent<ReportsButtonProps> = ({
  orgSlug
}) => {
  return (
    <>
      <ButtonLink 
        href={`/organizations/${orgSlug}/standard_reports`} 
        look={ButtonLooks.Tertiary}
        size={ButtonSizes.Small}>
        <FontIcon icon={FontIcons.Reports} />
        {bfTranslate('Reports')}
      </ButtonLink>
    </>
  );
};

export default ReportsButton;